import React from 'react';
import { Form } from 'react-bootstrap';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { InputContainer } from '../styles';
import InputMask from 'react-input-mask';
import { AiOutlineSearch } from 'react-icons/ai';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

interface InputMaskProps {
  label?: string;
  name: string;
  isError: boolean;
  alwaysShowMask?: boolean;
  control: Control<FieldValues, any>;
  hasButton?: boolean;
  loadingIcon?: boolean;
  clickedButton?: () => void;
  disabled?: boolean;
}

export const InputMaskCep: React.FC<InputMaskProps> = ({
  label = '',
  name,
  isError,
  alwaysShowMask = false,
  control,
  hasButton = false,
  loadingIcon = false,
  clickedButton,
  disabled = false,
  ...rest
}) => {
  return (
    <>
      <InputContainer>
        <Form.Group>
          <Form.Label>{label}</Form.Label>
          <Controller
            name={name}
            control={control}
            render={({ field: { value, onChange, onBlur, ref } }) => {
              return (
                <InputMask
                  mask="99999-999"
                  alwaysShowMask={alwaysShowMask}
                  placeholder="00000-000"
                  onChange={(event) =>
                    onChange(event.target.value.toUpperCase())
                  }
                  onBlur={onBlur}
                  value={value || ''}
                  className={
                    isError ? 'form-control is-invalid' : 'form-control'
                  }
                  {...rest}
                >
                  {(inputProps: any) => {
                    return (
                      <div style={{ position: 'relative' }}>
                        <input
                          {...inputProps}
                          name={name}
                          type="text"
                          ref={ref}
                          disabled={disabled}
                        />
                        {hasButton && (
                          <CustomButtonNovo
                            className="button-input"
                            onClick={() => {
                              if (clickedButton) {
                                clickedButton();
                              }
                            }}
                            icon={AiOutlineSearch}
                            iconOnly
                            showLoading={loadingIcon}
                            iconSize={15}
                          />
                        )}
                      </div>
                    );
                  }}
                </InputMask>
              );
            }}
          />
        </Form.Group>
      </InputContainer>
    </>
  );
};
